import { render, staticRenderFns } from "./scoreboard.vue?vue&type=template&id=bf91b376&"
import script from "./scoreboard.vue?vue&type=script&lang=js&"
export * from "./scoreboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports